//
import { FormattedMessage } from "react-intl";
//
import groupIcon from "../../../images/avatar_group/avatar_group.svg";
import folderIcon from "../../../images/icon_folder/icon_folder.svg";
import folderIconActive from "../../../images/icon_folder/icon_folder_active.svg";
import filterIcon from "../../../images/icon_filter/icon_filter.svg";
import filterIconActive from "../../../images/icon_filter/icon_filter_active.svg";
import adjustIcon from "../../../images/icon_sun/icon_sun.svg";
import adjustIconActive from "../../../images/icon_sun/icon_sun_active.svg";
import chartIcon from "../../../images/icon_chart/icon_chart.svg";
import chartIconActive from "../../../images/icon_chart/icon_chart_active.svg";
import digitalAIIcon from "../../../images/icon_digitalAI/icon_digitalAI.svg";
import digitalAIIconActive from "../../../images/icon_digitalAI/icon_digitalAI_active.svg";
import evnCtgIcon from "../../../images/icon_evn_setting/icon_evn_setting.svg";
import evnCtgIconActive from "../../../images/icon_evn_setting/icon_evn_setting_active.svg";
import helpIcon from "../../../images/icon_help/icon_help.svg";

import AnalyticsTool from "./components/sidebar/analyticsTool/AnalyticsTool";
import FilterTool from "./components/sidebar/filterTool/FilterTool";
import AdjustTool from "./components/sidebar/adjustTool/AdjustTool";
import FileTool from "./components/sidebar/fileTool/FileTool";
import GroupTool from "./components/sidebar/groupTool/GroupTool";
import EvnCtgSettingTool from "./components/sidebar/evnCtgSettingTool/EvnCtgSettingTool";
//

// eslint-disable-next-line import/named
import { ROUTE_PATH, MODULE_ID } from "../../config/CONSTANTS";
// eslint-disable-next-line import/no-cycle
import DigitalAITool from "./components/sidebar/digitalAITool/DigitalAITool";

export const sidebarConfig = {
  content: [
    {
      name: "group",
      component: GroupTool,
      children: { header: {}, body: {}, footer: {} },
    },
    {
      name: "file",
      component: FileTool,
      children: { header: {}, body: {}, footer: {} },
    },
    {
      name: "digitalAI",
      component: DigitalAITool,
      children: { header: {}, body: {}, footer: {} },
    },
    {
      name: "adjust",
      component: AdjustTool,
      children: { header: {}, body: {}, footer: {} },
    },
    {
      name: "filter",
      component: FilterTool,
      children: { header: {}, body: {}, footer: {} },
    },
    {
      name: "analytics",
      component: AnalyticsTool,
      children: { header: {}, body: {}, footer: {} },
    },
    {
      name: "evnCtgSetting",
      component: EvnCtgSettingTool,
      children: { header: {}, body: {}, footer: {} },
    },
  ],
};

export const sideToolConfig = {
  group: {
    name: "group",
    hint: "預設團隊",
    defaultMessage: "預設團隊",
    intlExtract: (
      <FormattedMessage id="sidetool.group" defaultMessage="預設團隊" />
    ),
    intl18Id: "sidetool.group",
    moduleId: MODULE_ID.snaSidetoolGroup,
    iconSrc: groupIcon,
    iconActiveSrc: groupIcon,
  },
  topItems: [
    {
      name: "file",
      className: "sideTool-file",
      hint: "資料集",
      defaultMessage: "資料集",
      intlExtract: (
        <FormattedMessage id="sidetool.file" defaultMessage="資料集" />
      ),
      intl18Id: "sidetool.file",
      moduleId: MODULE_ID.snaSidetoolDataset,
      iconSrc: folderIcon,
      iconActiveSrc: folderIconActive,
    },
    {
      name: "digitalAI",
      className: "sideTool-digitalAI",
      hint: "數位小助理",
      defaultMessage: "數位小助理",
      intlExtract: (
        <FormattedMessage id="sidetool.digitalAI" defaultMessage="數位小助理" />
      ),
      intl18Id: "sidetool.digitalAI",
      moduleId: MODULE_ID.snaSidetoolDigitalAI,
      iconSrc: digitalAIIcon,
      iconActiveSrc: digitalAIIconActive,
    },
    {
      name: "adjust",
      className: "sideTool-adjust",
      hint: "外觀",
      defaultMessage: "外觀",
      intlExtract: (
        <FormattedMessage id="sidetool.adjust" defaultMessage="外觀" />
      ),
      intl18Id: "sidetool.adjust",
      moduleId: MODULE_ID.snaSidetoolAdjust,
      iconSrc: adjustIcon,
      iconActiveSrc: adjustIconActive,
    },
    {
      name: "filter",
      className: "sideTool-filter",
      hint: "篩選",
      defaultMessage: "篩選",
      intlExtract: (
        <FormattedMessage id="sidetool.filter" defaultMessage="篩選" />
      ),
      intl18Id: "sidetool.filter",
      moduleId: MODULE_ID.snaSidetoolFilter,
      iconSrc: filterIcon,
      iconActiveSrc: filterIconActive,
    },
    {
      name: "analytics",
      className: "sideTool-analytics",
      hint: "數據分析",
      defaultMessage: "數據分析",
      intlExtract: (
        <FormattedMessage id="sidetool.analytics" defaultMessage="數據分析" />
      ),
      intl18Id: "sidetool.analytics",
      moduleId: MODULE_ID.snaSidetoolAnalytics,
      iconSrc: chartIcon,
      iconActiveSrc: chartIconActive,
    },
    {
      name: "evnCtgSetting",
      className: "sideTool-evnCtgSetting",
      hint: "事件分類設定",
      defaultMessage: "事件分類設定",
      intlExtract: (
        <FormattedMessage
          id="sidetool.evnCtgSetting"
          defaultMessage="事件分類設定"
        />
      ),
      intl18Id: "sidetool.evnCtgSetting",
      moduleId: MODULE_ID.snaSidetoolEvnCtgSetting,
      iconSrc: evnCtgIcon,
      iconActiveSrc: evnCtgIconActive,
    },
  ],
  bottomItems: [
    // {
    //   name: "help",
    //   hint: "幫助中心",
    //   className: "sideTool-help",
    //   defaultMessage: "幫助中心",
    //   intlExtract: (
    //     <FormattedMessage id="sidetool.help" defaultMessage="幫助中心" />
    //   ),
    //   intl18Id: "sidetool.help",
    //   moduleId: MODULE_ID.snaSidetoolHelp,
    //   iconSrc: helpIcon,
    //   iconActiveSrc: helpIcon,
    //   link: ROUTE_PATH.Help,
    // },
  ],
};

export const drawerWidth = 240;

// drawer 右邊的區塊
export const SNA_MAIN_ID = "sna__main";

// sna display area
export const SNA_DISPLAY_DIV_ID = "sna_display_area";

// sna display area 外的 div
export const SNA_WRAPPER_DIV_ID = "sna_display_area_wrapper";

export const tourSteps = [
  // sidetool
  {
    selector: ".sideTool-file",
    content: "This is my first Step",
  },
  // top panel: 匯入,匯出,當前資料集

  // sna graph

  // graph tool: fullscreen, diary info, analytics
];
